// Shared looks for things that float above the page, so every menu, list and popover matches
// (DESIGN.md: hairlines before shadows; shadow-float only on sheets and popovers).

/** Popover, dropdown menu, select list, command list. */
export const floatingSurface = [
  "z-50 rounded-md border border-border bg-popover text-popover-foreground shadow-float",
  "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
  "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
  "data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1",
  "data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 duration-150",
].join(" ");

/** One choosable row in a menu or list. Highlighted (keyboard or pointer) = muted. */
export const menuItem = [
  "relative flex min-h-9 cursor-default select-none items-center gap-space-2 rounded-sm px-space-2 type-body",
  "data-[highlighted]:bg-muted data-[selected=true]:bg-muted",
  // Radix marks disabled items data-disabled; cmdk writes data-disabled="false" on every item.
  "[&[data-disabled]:not([data-disabled=false])]:pointer-events-none [&[data-disabled]:not([data-disabled=false])]:text-faint-foreground",
  "[&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg]:[stroke-width:1.75] [&_svg:not([class*='size-'])]:size-4",
  "[&_svg:not([class*='text-'])]:text-muted-foreground",
].join(" ");

/** The dimmed page behind a dialog or sheet. */
export const backdrop =
  "fixed inset-0 z-50 bg-black/40 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0";
